export default "__VITE_ASSET__7aee407e__"